/** @deprecated Use ALL_MAPPING_KINDS from drawingTaxonomy.js — kept for legacy imports */
export { ALL_MAPPING_KINDS as PILOT_MAPPING_KINDS } from './drawingTaxonomy';

export const OVERLAY_STATUS_OPTIONS = [
  { value: 'all', label: 'All statuses' },
  { value: 'auto_validated', label: 'Auto-validated' },
  { value: 'user_confirmed', label: 'Confirmed' },
  { value: 'pending_user_confirm', label: 'Unknown' },
  { value: 'needs_review', label: 'Needs review' },
];

export const OVERLAY_AXIS_OPTIONS = [
  { value: 'all', label: 'All axes' },
  { value: 'reference_annotation', label: 'Reference' },
  { value: 'dimensional_output', label: 'Dimensional' },
  { value: 'building_component', label: 'Component' },
];

export const TAXONOMY_AXIS_OPTIONS = [
  { value: 'reference_annotation', label: 'Reference annotation' },
  { value: 'dimensional_output', label: 'Dimensional output' },
  { value: 'building_component', label: 'Building component' },
];
